import React, { createContext, useContext, useEffect, useState } from 'react';

const DataContext = createContext();

export const useData = () => useContext(DataContext);

export const DataProvider = ({ children }) => {
    const [experienceData, setExperienceData] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const [projectsData, setProjectsData] = useState([]);
    const [educationData, setEducationData] = useState({});
    const [courseSongsData, setCourseSongsData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [expRes, blogRes, projRes, eduRes, songsRes] = await Promise.all([
                    fetch('/data.json'),
                    fetch('/blog.json'),
                    fetch('/projects.json'),
                    fetch('/education.json'),
                    fetch('/course-songs.json')
                ]);

                const expData = await expRes.json();
                const blgData = await blogRes.json();
                const projData = await projRes.json();
                const eduData = await eduRes.json();
                const songsData = await songsRes.json();

                setExperienceData(expData);
                setBlogData(blgData);
                setProjectsData(projData);
                setEducationData(eduData);
                setCourseSongsData(songsData);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const value = {
        experienceData,
        blogData,
        projectsData,
        educationData,
        courseSongsData,
        loading
    };

    return (
        <DataContext.Provider value={value}>
            {children}
        </DataContext.Provider>
    );
};
